import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-warning-message-modall',
    templateUrl: './warning-message-modal.component.html',
    styleUrls: ['./warning-message-modal.component.scss']
})
export class WarningMessageModalComponent {
    constructor(
        public dialogRef: MatDialogRef<WarningMessageModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    getTitle() {
        return this.data.title;
    }
}
